module.exports = __webpack_public_path__ + "5f4d38ac5307ba002183763faf8bd013.pdf";